<template>
    <div v-if="availableAdditionalOptions.length > 0">
        <!-- All available accessories -->
        <div class="checkout-accessories accessories-available">
            <div class="promo-text">
                <h4 class="block-title text-dark">Additional Options</h4>
            </div>
            <OwlCarousel class="accessories-items-container"
                         :responsive="{
                                0: {
                                    items: 1.1
                                },
                                500: {
                                    items: 2
                                },
                                900: {
                                    items: 3
                                },
                                1500: {
                                    items: 4.6
                                }
                         }"
                         :center="true"
                         :loop="false"
                         :nav="false"
                         :dots="false">
                <div v-for="option in availableAdditionalOptions" :key="option.id" class="accessory-item" @click="addToCart(option)" v-tooltip:top="'Add ' + option.name">
                    <img src="/assets/images/logo/logo.svg" alt="">
                    <span>{{ option.name }}</span>
                </div>
            </OwlCarousel>
        </div>

        <!-- All additional options in cart -->
        <div class="checkout-list">
            <div v-show="additionalOptions.length === 0" class="text-center">
                <h5 class="mt-5">No additional options was added</h5>
            </div>
            <div v-for="(option, index) in additionalOptions" :key="index" class="cart-item">
                <div class="cart-item-container">
                    <div class="item-info">
                        <h4 class="title">{{ option.item.name }}</h4>
                        <a class="item-action-remove" href="javascript:void(0);" @click="removeAdditionalOption(index)">
                            <span class="bi bi-x-circle"></span> Remove
                        </a>
                    </div>
                    <div class="item-controls">
                        <NumberSelector :min="1" class="style-01" v-model="option.amount" />
                        <h5 class="total">{{ itemTotalPrice(option) | filterPrice }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OwlCarousel from "vue-owl-carousel";
import ApiRequest from "../../../../utils/api-request";
import {mapActions, mapGetters} from "vuex";
import CartItem from "../../../../models/CartItem";
import SettingsMixin from "../../../../mixins/SettingsMixin";
import AdditionalOptionItem from "../../../../models/AdditionalOptionItem";

export default {
    name: "CheckoutAdditionalOptions",
    mixins: [SettingsMixin],
    components: {
        OwlCarousel
    },
    props: {
        isEvent: {
            type: Boolean,
            default: false
        },
        eventId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            availableAdditionalOptions: []
        }
    },
    computed: {
        ...mapGetters('cart', ['additionalOptions'])
    },
    mounted() {

        if(this.isEvent) {
            new ApiRequest().getEventAdditionalOptions(this.eventId).then(
                (response) => {
                    this.availableAdditionalOptions = response.data.additional_options;
                }
            )

        } else {
            new ApiRequest().getAdditionalOptions(this.settings.locationId).then(
                (response) => {
                    this.availableAdditionalOptions = response.data.additional_options;
                }
            )
        }


    },
    methods: {
        ...mapActions('cart', ['addAdditionalOption', 'removeAdditionalOption']),
        addToCart(option) {
            this.addAdditionalOption(new AdditionalOptionItem(option, 1));
        },
        itemTotalPrice(option) {
            return option.item.additional_option_location_prices.price * option.amount;
        }
    }
}
</script>

<style scoped>

</style>
